import { gql, graphQueryBang } from "../../../shared/lib/graphql"
import { appletQueryFields as StaticAppletFragment } from "./reducers/applet"
import { serviceQueryFields as ServicesFragment } from "./reducers/services"

const PrivateServicesQuery = gql`
  query PrivateServicesQuery {
    me {
      private_channels {
        ${ServicesFragment}
      }
    }
  }
`

const StaticAppletAndTagsQuery = gql`
  query StaticAppletAndTagsQuery(
    $applet_id: String!
  ) {
    applet(id: $applet_id) {
      ${StaticAppletFragment}
    }
    applet_tags { id name }
  }
`

const AppletTagsQuery = gql`
  query AppletTagsQuery {
    applet_tags { id name }
  }
`

export function loadPrivateServices() {
  return graphQueryBang(PrivateServicesQuery).then(data => data.me.private_channels)
}

export function loadStaticApplet(appletId) {
  return graphQueryBang(StaticAppletAndTagsQuery, {
    applet_id: appletId,
  }).then(data => {
    return { applet: data.applet, tags: data.applet_tags }
  })
}

export function loadTags() {
  return graphQueryBang(AppletTagsQuery).then(data => ({ tags: data.applet_tags }))
}
